import { render, staticRenderFns } from "./ProductAddToCartButton.vue?vue&type=template&id=1ec4b14e&scoped=true&"
import script from "./ProductAddToCartButton.vue?vue&type=script&lang=js&"
export * from "./ProductAddToCartButton.vue?vue&type=script&lang=js&"
import style0 from "./ProductAddToCartButton.vue?vue&type=style&index=0&id=1ec4b14e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec4b14e",
  null
  
)

export default component.exports